import { Button, DatePicker, Input } from "antd";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance/AxiosInstance";
import { useParams } from "react-router-dom";
import { OneCustomer } from "../../../Stores/Customers/OneCustomer";
import { IoNotificationsOutline } from "react-icons/io5";

export default function Notify() {
  let { id } = useParams();
  let { data, fetchNotificationsData } = OneCustomer();
  let [notifyData, setNotifyData] = useState({
    customer_id: id,
    message: null,
    comment: null,
    date: "2025-04-08 04:17:58:58",
  });
  let [loading, setLoading] = useState(false);
  // fetchNotificationsData
  const onOk = (value) => {
    console.log("onOk: ", value);
  };
  useEffect(() => {
    fetchNotificationsData(id);
  }, []);

  let postNotificationsData = async () => {
    if (loading) return;
    try {
      let { data: info } = await axiosInstance.post("/api/notifications", {
        ...notifyData,
        customer_id: id,
      });
      console.log("data");
      console.log(notifyData);
      console.log(info);
      fetchNotificationsData(id);
      console.log("notified");
      console.log(data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <div className="mb-[18px]">
        <h2>Bildirishnoma</h2>
        <div className="mb-[18px]">
          <DatePicker
            className="text-[20px]"
            showTime
            // value={notifyData?.date ? notifyData?.date : null}
            onChange={(value, dateString) => {
              console.log("Selected Time: ", value);
              console.log("Formatted Selected Time: ", dateString);
              setNotifyData({
                ...notifyData,
                date: dateString?.split(" ").join("T"),
              });
            }}
            onOk={onOk}
            placeholder="Xabar sanasini tanlang"
          />
        </div>
        <div className="mb-[18px]">
          <Input
            type="text"
            className="text-[20px]"
            placeholder="Xabar sarlovxasi....."
            value={notifyData?.message}
            onChange={(e) => {
              setNotifyData({
                ...notifyData,
                message: e.target.value,
              });
            }}
          />
        </div>
        <div className="mb-[18px]">
          <Input.TextArea
            className="text-[20px]"
            type="text"
            value={notifyData?.comment}
            placeholder="Xabar matni....."
            onChange={(e) => {
              setNotifyData({
                ...notifyData,
                comment: e.target.value,
              });
            }}
          />
        </div>
        <div>
          <Button
            onClick={() => {
              setLoading(true);
              postNotificationsData();
            }}
          >
            Saqlash
          </Button>
        </div>
      </div>
      <div className="border-[1px] border-[#bfbfbf] h-[150px] overflow-auto p-2">
        {data?.notify?.planned?.map((el) => {
          return (
            <div class="sm:flex sm:items-start w-[100%]">
              <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                {/* <svg
                  class="size-6 text-red-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  aria-hidden="true"
                  data-slot="icon"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                  />
                </svg> */}
                <IoNotificationsOutline className="text-[red] text-[30px]" />
              </div>
              <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3
                  class="w-[100%] text-base font-semibold text-gray-900 flex flex-row items-center justify-between gap-[30px]"
                  id="modal-title"
                >
                  <span> {el?.message} </span>
                  <span className="text-[16px] text-[#bfbfbf]">
                    {" "}
                    {el?.date?.split("T")?.join(" ")}
                  </span>
                </h3>
                <div class="mt-2">
                  <p class="text-sm text-gray-500">{el?.comment}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
